<template>
	<v-app>
		<NavView>
		</NavView>
		<v-main app>
			<v-card>
				<v-tabs v-model="activeTab">
					<v-tab @click="getEnquiry()">
						询价
					</v-tab>
					<v-tab @click="getQuotation()">
						我的报价
					</v-tab>
				</v-tabs>

				<v-tabs-items v-model="activeTab">
					<v-tab-item>
						<v-container>
							<v-row align="center" style="margin-top: 10px;margin-bottom: 10px;">
								<v-checkbox label="显示全部" v-model="showAllEnquiry" hide-details @change="getEnquiry()"
									style="vertical-align:bottom;margin-left:10px;"></v-checkbox>
								<v-checkbox label="报价统计" v-model="showQuotationStats" hide-details class="ml-3"
									style="vertical-align:bottom;"></v-checkbox>

								<v-btn small @click="getEnquiry()"
									style="vertical-align:bottom;margin-left:10px;">刷新</v-btn>
							</v-row>
						</v-container>
						<v-card v-if="enquirys.length > 0">
							<v-data-table :headers="headersEnquiry" v-model="selected" :items="enquirys"
								:items-per-page="10" hover striped class="elevation-1" item-key="id">
								<template slot="item.actions" slot-scope="{ item }">
									<v-btn small class="mr-1" v-if="item.files && item.files != 'null'"
										@click="viewEnquiryFiles(item)">查看图纸</v-btn>
									<v-btn small color="primary" @click="addQuotation(item); getEnquiry();">报价</v-btn>
								</template>
							</v-data-table>
						</v-card>
						<p class="text-center" v-if="enquirys.length == 0"><span v-if="showAllEnquiry"
								color="red accent-2">没有询价</span><span v-else color="red accent-2">没有未报价询价</span></p>
					</v-tab-item>
					<v-tab-item>
						<v-card>
							<v-container>
								<v-row justify="center" style="margin-top: 10px;margin-bottom: 10px;">
									<v-btn @click="delSure = true;" small>
										删除
									</v-btn>
								</v-row>
							</v-container>
							<v-data-table show-select :headers="headersQuotation" :items="quotations"
								:items-per-page="10" v-model="selectedQuotation" item-key="id">
								<template slot="item.drawing" slot-scope="{ item }">
									<a v-if="item.drawing && item.drawing != 'null'" href="javascript:void(0)"
										@click="viewDrawing(item)">查看</a>
								</template>
							</v-data-table>
						</v-card>
					</v-tab-item>
				</v-tabs-items>

				<v-dialog v-model="addDivShow" max-width="500px">
					<v-card>
						<v-card-title class="text-h5">新增询价产品</v-card-title>
						<v-card-text>
							<v-text-field label="名称" v-model="newEnquiry.name"></v-text-field>
							<v-text-field label="型号" v-model="newEnquiry.model"></v-text-field>
							<v-text-field label="数量" v-model="newEnquiry.number"></v-text-field>
							<v-file-input multiple show-size v-model="newEnquiryFiles" accept="image/*"></v-file-input>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="blue-darken-1" variant="text" @click="addDivShow = false">取消</v-btn>
							<v-btn color="blue-darken-1" variant="text" @click="addEnquiry">确定</v-btn>
							<v-spacer></v-spacer>
						</v-card-actions>
					</v-card>
				</v-dialog>

				<v-dialog v-model="showEnquiry" max-width="500px">
					<v-card>
						<v-card-title class="text-h5">产品附件</v-card-title>
						<v-card-text>
							<div style="margin:20px;color: chocolate;">{{ imgMsg }}</div>
							<div style="padding: 5px;"><span v-if="Array.isArray(newEnquiry.files)">
									<span v-if="newEnquiry.files.length > 0">
										<v-chip v-for="(file, index) in newEnquiry.files" @click="fetchImage(file)"
											:key="index">
											{{ index + 1 }}
										</v-chip>
									</span>
								</span>
							</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="blue-darken-1" variant="text" @click="showEnquiry = false">关闭</v-btn>
							<v-spacer></v-spacer>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-dialog v-model="delSure" width="300">
					<v-card>
						<v-card-title class="text-h5">确认删除报价</v-card-title>
						<v-card-text>
							<span
								v-if="selectedQuotation.length > 0">确定要删除{{ selectedQuotation.length }}条询价吗？</span><br />{{ delSureMsg }}
						</v-card-text>
						<v-card-actions style="text-align:center;">
							<v-spacer></v-spacer>
							<v-btn color="blue-darken-1" variant="text" @click="delQuotation()" small
								v-if="selectedQuotation.length > 0">确定</v-btn>
							<v-btn color="blue-darken-1" variant="text" @click="delSure = false" small>关闭</v-btn>
							<v-spacer></v-spacer>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-dialog v-model="addQuotationDiv" max-width="500">
					<v-card>
						<v-card-title class="text-h5">添加报价</v-card-title>
						<v-card-text>
							<div style="margin:20px;color: chocolate;">{{ filesMsg }}</div>
							<v-text-field label="价格（必填）" v-model="newQuotation.price" type="number" :rules="numberRules"
								required></v-text-field>
							<v-text-field label="说明" v-model="newQuotation.more"></v-text-field>
							<!--<v-file-input multiple show-size v-model="newQuotationFiles"
								accept="image/*"></v-file-input> -->
							历史报价：
							<ul>
								<li v-for="(item, index) in oldQuotation" :key="index">
									日期：{{ item.createdTime }} 报价：{{ item.price }}元</li>
							</ul>
							<div style="color:red;">{{ addQuotationMsg }}</div>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer><v-btn color="blue-darken-1" variant="text"
								@click="saveQuotation()">确定</v-btn>
							<v-btn color="blue-darken-1" variant="text" @click="addQuotationDiv = false">关闭</v-btn>
							<v-spacer></v-spacer>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-dialog v-model="showMsg" max-width="500px">
					<v-card>
						<v-card-title class="text-h5">提示<v-icon
								@click="showMsg = false; msg = null;">mdi-close</v-icon></v-card-title>
						<v-card-text>
							{{ msg }}
						</v-card-text>
					</v-card>
				</v-dialog>

				<v-dialog v-model="showImage" max-width="90vw">
					<v-card>
						<v-card-title class="text-h5">图纸
							<v-spacer></v-spacer>
							<v-icon @click="closeImage()">mdi-close</v-icon>
						</v-card-title>
						<v-card-text class="text-center">
							<img v-if="imageUrl" :src="imageUrl" style="max-width:100%;max-height:70vh;" />
							<div v-else-if="showPdf">
								<div v-if="pdfLoading" style="color:chocolate;padding:20px;">PDF 加载中…</div>
								<div v-else-if="pdfTotalPages > 0" class="pdf-toolbar">
									<v-btn small icon @click="pdfPrevPage()" :disabled="pdfPageNum <= 1">
										<v-icon>mdi-chevron-left</v-icon>
									</v-btn>
									<span style="margin:0 6px;">{{ pdfPageNum }} / {{ pdfTotalPages }}</span>
									<v-btn small icon @click="pdfNextPage()" :disabled="pdfPageNum >= pdfTotalPages">
										<v-icon>mdi-chevron-right</v-icon>
									</v-btn>
									<v-divider vertical class="mx-2"></v-divider>
									<v-btn small icon @click="pdfZoomOut()">
										<v-icon>mdi-magnify-minus</v-icon>
									</v-btn>
									<span style="margin:0 6px;">{{ Math.round(pdfScale * 100) }}%</span>
									<v-btn small icon @click="pdfZoomIn()">
										<v-icon>mdi-magnify-plus</v-icon>
									</v-btn>
								</div>
								<div ref="pdfScroll"
									style="overflow:auto;max-height:65vh;text-align:center;background:#525659;">
									<canvas ref="pdfCanvas"></canvas>
								</div>
							</div>
							<div v-else-if="imgMsg" style="color:chocolate;">{{ imgMsg }}</div>
						</v-card-text>
					</v-card>
				</v-dialog>
			</v-card>
		</v-main>
	</v-app>
</template>

<script>
import NavView from "./../components/NavBar";
import * as pdfjsLib from 'pdfjs-dist';
pdfjsLib.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.entry.js');
export default {
	name: 'QuotationView',
	components: {
		NavView,
	},
	data: () => ({
		activeTab: 0,
		showQuotationStats: false,
		quotations: [],
		enquirys: [],
		newEnquiry: {
			name: null,
			model: null,
			number: null,
			files: []
		},
		showEnquiry: false,
		newEnquiryFiles: null,
		addDivShow: false,
		selected: [],
		scale: 1,
		minScale: 0.5,
		maxScale: 3,
		originX: 50, // 默认以图片中心为缩放原点
		originY: 50,
		position: {
			x: 0,
			y: 0
		},
		isDragging: false,
		startPos: {
			x: 0,
			y: 0
		},
		imageUrl: null,
		showPdf: false,
		pdfLoading: false,
		pdfPageNum: 1,
		pdfTotalPages: 0,
		pdfScale: 1,
		showMsg: false,
		msg: null,
		delNum: 0,
		addQuotationDiv: false,
		newQuotation: {
			price: null,
			files: null,
			more: null,
			enquiryId: null,
			purpose: null,
			drawing: null
		},
		newQuotationFiles: null,
		imgMsg: null,
		uploadedFiles: [],
		filesMsg: null,
		selectedQuotation: [],
		numberRules: [
			v => !!v || '此项为必填项',
			v => /^\d*\.?\d{0,2}$/.test(v) || '只能输入数字'
		],
		oldQuotation: [],
		addQuotationMsg: null,
		showAllEnquiry: false,
		showImage: false,
		currentEnquiry: null,
		delSure: false,
		delSureMsg: null
	}),
	computed: {
		headersEnquiry() {
			let headers = [{
				text: "时间",
				value: "createTime"
			}, {
				text: "品名",
				value: "name"
			},
			{
				text: '型号',
				value: 'model',
			}, {
				text: '单位',
				value: 'unit',
			}, {
				text: '数量',
				value: 'number',
			}, {
				text: '备注',
				value: 'purpose'
			}];
			if (this.showQuotationStats) {
				headers.push({
					text: '报价次数',
					value: 'quotationNum'
				}, {
					text: '最高报价',
					value: 'quotationMax'
				}, {
					text: '最低报价',
					value: 'quotationMin'
				});
			}
			headers.push({
				text: '操作',
				value: 'actions',
				sortable: false
			});
			return headers;
		},
		headersQuotation() {
			const isMobile = this.$vuetify.breakpoint.xsOnly;
			let headers = [{ text: '创建时间', value: 'createdTime', }, { text: "名称", value: "name" }, { text: "型号", value: "model" }, { text: "图纸", value: "drawing" }, { text: "报价", value: "price" },];
			if (!isMobile) { headers.push({ text: "单位", value: "unit" }, { text: "数量", value: "number" }); }
			headers.push({ text: "备注", value: "purpose" });
			return headers;
		}
	},
	watch: {
		length(val) {
			this.tab = val - 1
		},
	},
	created() {
		this.getEnquiry();
	},
	methods: {
		getEnquiry() {
			this.$axios.post(this.serverUrl + "/enquiry/getAllEnquiry", null, {
				params: {
					onlyUnquoted: !this.showAllEnquiry
				}
			}).then(res => {
				if (res.data.data != null) {
					this.enquirys = res.data.data;
				}
			});
		},
		add() {
			this.newEnquiry.name = null;
			this.newEnquiry.model = null;
			this.newEnquiry.number = null;
			this.newEnquiry.files = [];
			this.addDivShow = true;

		},
		close() {
			this.addDivShow = false;
			this.newEnquiry.name = null;
			this.newEnquiry.model = null;
			this.newEnquiry.number = null;
			this.newEnquiry.files = [];
		},
		async addEnquiry() {
			await this.upload(this.newEnquiryFiles);
			this.newEnquiry.files = this.uploadedFiles;
			this.$axios.post(this.serverUrl + "/enquiry/addEnquiry", this.newEnquiry).then(res => {
				if (res.data.state == 200) {
					this.close();
					this.getEnquiry();
				} else {
					this.showMsg = true;
					this.msg = "添加失败，联系系统管理员。";
				}
			});
		},
		async upload(files) {
			this.uploadedFiles = [];
			if (files != null) {
				for (const file of files) {

					const formData = new FormData();
					formData.append('file', file);

					const response = await this.$axios.post(this.serverUrl + '/file/upload', formData, {
						headers: {
							'Content-Type': 'multipart/form-data' // 必须明确设置
						}
					});

					if (response.data.state === 200) {
						this.uploadedFiles.push(response.data.data)
					}
				}
			}
		},
		show() {
			this.imageUrl = null;
			this.imgMsg = null;
			if (this.selected.length == 1) {
				this.newEnquiry = this.selected[0];
				if (typeof (this.newEnquiry.files) == "string") {
					this.newEnquiry.files = JSON.parse(this.newEnquiry.files);
				}
				this.showEnquiry = true;
			} else {
				this.showMsg = true;
				this.msg = "请选择一条记录！";
			}
		},
		/* delSure() {
			if (!this.selected.length == 0) {
				this.delSure = true;
				this.delNum = this.selected.length;
			}
		}, */
		//del() {
		//this.selected.forEach((item) => {
		//item.files = null;
		/* })
		this.$axios.post(this.serverUrl + "/enquiry/delEnquiry", this.selected).then(
			res => {
				console.log(res);
				if (res.data.state === 200) {
					this.getEnquiry();
				}
			}
		);
	}, */
		async addQuotation(item) {
			if (item != null) {
				this.currentEnquiry = item;
				await this.$axios.post(this.serverUrl + "/enquiry/getQuotationByEnquiryIdandVenderId", {
					enquiryId: item.id
				}).then(res => {
					if (res.data.state === 200 && res.data.data != null) {
						this.oldQuotation = res.data.data;
					}
				})
				this.addQuotationMsg = null;
				this.addQuotationDiv = true;
			} else {
				this.showMsg = true;
				this.msg = "请选择一条记录！";
			}
		},
		async getQuotation() {
			await this.$axios.post(this.serverUrl + "/enquiry/getQuotation", this.newQuotation, {
				headers: {
					token: localStorage.getItem("authToken")
				}
			}).then(res => {
				if (res.data.state === 200 && res.data.data != null) {
					this.quotations = res.data.data;
				}
			})
		},
		async saveQuotation() {
			await this.upload(this.newQuotationFiles);
			this.newQuotation.files = this.uploadedFiles;
			this.newQuotation.enquiryId = this.currentEnquiry.id;
			this.newQuotation.purpose = this.currentEnquiry.purpose;
			this.newQuotation.drawing = this.currentEnquiry.files;

			let checkPrice = true;
			this.oldQuotation.forEach(item => {
				if (item.price == this.newQuotation.price) {
					checkPrice = false;
				}
			})

			if (checkPrice) {
				this.$axios.post(this.serverUrl + "/enquiry/addQuotation", this.newQuotation, {
					headers: {
						token: localStorage.getItem("authToken")
					}
				}).then((res) => {
					if (res.data.state === 200) {
						this.addQuotationDiv = false;
						this.newQuotation.price = null;
						this.newQuotation.more = null;
						this.newQuotation.files = null;
						this.newQuotation.enquiryId = null;
						this.currentEnquiry = null;
						this.getEnquiry();
					}
				})
			} else {
				this.addQuotationMsg = "报价重复!";
			}
		},
		delQuotation() {
			this.delSureMsg = null;
			let ids = [];
			this.selectedQuotation.forEach((item) => {
				ids.push(item.id);
			})
			if (ids.length > 0) {
				this.$axios.post(this.serverUrl + "/enquiry/delQuotation", {
					id: ids
				}).then(
					res => {
						if (res.data.state === 200) {
							this.getQuotation();
							this.selectedQuotation = [];
							this.delSure = false;
						}
					}
				)
			} else {
				this.delSureMsg = "<span style='color:red'>没有选择项目</span>";
			}
		},
		fetchImage(findFileId) {

			this.loading = true;
			this.error = null;
			this.imgMsg = null;
			this.imageUrl = null;
			this.closePdf();
			// POST 请求示例（发送过滤参数）
			this.$axios.post(this.serverUrl + "/file/getFileFromYdn", {
				filters: {
					// width: 300,
					// height: 200,
					grayscale: true
				},
				fileId: findFileId
			}, {
				responseType: 'blob', // 必须指定响应类型
				headers: {
					token: localStorage.getItem("authToken")
				}
			}).then(response => {
				// 创建临时 URL，页内 dialog 展示（移动端 window.open 会被拦截）
				let contentType = (response.headers['content-type'] || '').toLowerCase();
				const blob = new Blob([response.data], {
					type: contentType
				});
				if (contentType.indexOf('application/pdf') >= 0) {
					// PDF 档：PDF.js canvas 渲染（全端兼容，不依赖浏览器内嵌查看器）
					this.renderPdf(blob);
				} else if (contentType.indexOf('image/') === 0) {
					// 图片：img 预览
					this.imageUrl = URL.createObjectURL(blob);
					this.imgMsg = null;
					this.showImage = true;
				} else {
					this.imgMsg = "不支持的文件类型";
					this.showImage = true;
				}
			}).catch(error => {
				if (error.response) {
					// 服务器返回了错误状态码（如 404）
					if (error.response.status === 404) {
						this.imageUrl = null;
						this.imgMsg = "图片丢失";
						this.showImage = true;
					} else {
						//console.log('其他错误:', error.response.status);
					}
				} else if (error.request) {
					// 请求已发送但无响应（如网络问题）
					//console.log('网络错误或无响应');
				} else {
					// 请求配置错误
					//console.log('请求配置错误:', error.message);
				}
			});
		},
		// ===== PDF.js 渲染（移动端/桌面统一） =====
		async renderPdf(blob) {
			this.showPdf = true;
			this.pdfLoading = true;
			this.pdfPageNum = 1;
			this.pdfTotalPages = 0;
			this.pdfScale = 1;
			this.showImage = true;
			try {
				const buf = await blob.arrayBuffer();
				this.pdfDoc = await pdfjsLib.getDocument({ data: buf }).promise;
				this.pdfTotalPages = this.pdfDoc.numPages;
				await this.$nextTick();
				await this.pdfRenderPage();
			} catch (e) {
				console.error('PDF 渲染失败', e);
				this.imgMsg = "PDF 加载失败";
			} finally {
				this.pdfLoading = false;
			}
		},
		async pdfRenderPage() {
			if (!this.pdfDoc) return;
			const canvas = this.$refs.pdfCanvas;
			if (!canvas) return;
			const page = await this.pdfDoc.getPage(this.pdfPageNum);
			const baseViewport = page.getViewport({ scale: this.pdfScale });
			// 适配屏幕宽度（首屏自动适配，缩放后按用户比例）
			const container = this.$refs.pdfScroll;
			let scale = this.pdfScale;
			if (container && this.pdfScale === 1) {
				const fitScale = (container.clientWidth - 8) / baseViewport.width;
				scale = Math.min(1, Math.max(0.2, fitScale));
			}
			const viewport = page.getViewport({ scale });
			const dpr = window.devicePixelRatio || 1;
			canvas.width = Math.floor(viewport.width * dpr);
			canvas.height = Math.floor(viewport.height * dpr);
			canvas.style.width = Math.floor(viewport.width) + 'px';
			canvas.style.height = Math.floor(viewport.height) + 'px';
			const ctx = canvas.getContext('2d');
			ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
			await page.render({ canvasContext: ctx, viewport }).promise;
		},
		pdfPrevPage() {
			if (this.pdfPageNum > 1) {
				this.pdfPageNum--;
				this.pdfRenderPage();
			}
		},
		pdfNextPage() {
			if (this.pdfPageNum < this.pdfTotalPages) {
				this.pdfPageNum++;
				this.pdfRenderPage();
			}
		},
		pdfZoomIn() {
			if (this.pdfScale < 4) {
				this.pdfScale = Math.round((this.pdfScale * 1.25) * 100) / 100;
				this.pdfRenderPage();
			}
		},
		pdfZoomOut() {
			if (this.pdfScale > 0.2) {
				this.pdfScale = Math.round((this.pdfScale / 1.25) * 100) / 100;
				this.pdfRenderPage();
			}
		},
		closePdf() {
			if (this.pdfDoc) {
				try { this.pdfDoc.destroy(); } catch (e) { console.warn(e); }
				this.pdfDoc = null;
			}
			this.showPdf = false;
			this.pdfLoading = false;
			this.pdfTotalPages = 0;
			this.pdfPageNum = 1;
			this.pdfScale = 1;
		},
		viewEnquiryFiles(item) {
			if (item.files && item.files != 'null') {
				let files = JSON.parse(item.files);
				if (files.length > 0) {
					this.fetchImage(files[0]);
				}
			}
		},
		viewDrawing(item) {
			if (item.drawing && item.drawing != 'null') {
				let files = JSON.parse(item.drawing);
				if (files.length > 0) {
					this.fetchImage(files[0]);
				}
			}
		},
		closeImage() {
			if (this.imageUrl) {
				URL.revokeObjectURL(this.imageUrl);
			}
			this.imageUrl = null;
			this.closePdf();
			this.showImage = false;
		},
		handleWheelZoom(e) {
			// 计算鼠标相对图片的位置百分比
			const rect = this.$refs.image.$el.getBoundingClientRect()
			this.originX = ((event.clientX - rect.left) / rect.width) * 100
			this.originY = ((event.clientY - rect.top) / rect.height) * 100

			// 计算缩放比例
			const delta = e.deltaY > 0 ? 0.9 : 1.1
			const newScale = Math.min(
				Math.max(this.scale * delta, this.minScale),
				this.maxScale
			)

			// 计算缩放后的位置补偿
			const scaleRatio = 1 - newScale / this.scale
			this.position.x += (e.clientX - rect.left - this.position.x) * scaleRatio
			this.position.y += (e.clientY - rect.top - this.position.y) * scaleRatio

			this.scale = newScale
		},
	}
}
</script>

<style></style>